import { MdOutlineKeyboardArrowRight } from "react-icons/md"
import { useNavigate, useLocation } from "react-router-dom"
import jwtDecode from "jwt-decode"

function DashboardNav({ className }) {
  const location = useLocation()
  const navigate = useNavigate()

  const role = jwtDecode(localStorage.getItem("token")).role

  return (
    <>
      {location.pathname === "/" && role === "Student" && (
        <div className={`${className} button-group flex-row gap-2 md:gap-6`}>
          <button
            className="shadow-3 flex items-center rounded-lg bg-secondary-yellow px-2 py-1 
            text-white hover:bg-[#fac021] sml:gap-1 md:rounded-[14px] md:px-4 lg:py-2 xl:gap-7"
            onClick={() => navigate("/curriculum")}
          >
            <span className="text-[12px] font-medium md:text-[14px]">
              Your Curriculum
            </span>
            <MdOutlineKeyboardArrowRight size={28} className="w-5 md:w-7" />
          </button>
          <button
            className="shadow-3 hidden items-center  rounded-lg bg-primary px-2 py-1 
            text-white hover:bg-[#4351d3] sml:flex sml:gap-1 md:rounded-[14px] md:px-4 lg:py-2 xl:gap-7"
            onClick={() => navigate("/my-application-&-account")}
          >
            <span className="text-[12px] font-medium md:text-[14px]">
              Your Calendar
            </span>
            <MdOutlineKeyboardArrowRight size={28} className="w-5 md:w-7" />
          </button>
        </div>
      )}
    </>
  )
}

export default DashboardNav
